import styled from "styled-components";

import * as Grid from "~/components/Grid";
import { Text, Subtitle as BaseTitle, TextProps } from "~/components/Text";

export const Header = styled(Grid.Columns).attrs({ multiline: true })`
  cursor: default;
`;
export const Title = styled(BaseTitle)`
  word-break: break-word;
  cursor: default;
`;
Title.defaultProps = {
  weight: "bolder",
};

export const Content = styled(Grid.Columns).attrs({ as: "dl", multiline: true })``;
export const Item = styled(Grid.Column)``;

export const Term = styled(Text as "dt").attrs<TextProps>({ as: "dt" })<TextProps>`
  cursor: default;
`;
Term.defaultProps = {
  weight: "bolder",
  color: "black",
  transform: "uppercase",
  size: "7",
};

export const Description = styled(Text as "dd").attrs<TextProps>({ as: "dd" })<TextProps>`
  /* https://css-tricks.com/snippets/css/prevent-long-urls-from-breaking-out-of-container/ */
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-all;
  /* Instead use this non-standard one: */
  word-break: break-word;
  hyphens: auto;
`;
Description.defaultProps = {
  color: "black",
};
